import { useState, useEffect, useRef } from 'react';
import { X } from 'lucide-react';

const PHASES = [
  { text: '5', bg: 'bg-emerald-500', duration: 1000 },
  { text: '4', bg: 'bg-teal-500', duration: 1000 },
  { text: '3', bg: 'bg-amber-500', duration: 1000 },
  { text: '2', bg: 'bg-orange-500', duration: 1000 },
  { text: '1', bg: 'bg-red-500', duration: 1000 },
  { text: 'Eyes and ears\non teacher\nnow', bg: 'bg-indigo-600', duration: 5000, final: true },
];

export const AttentionGetterOverlay = ({ onClose }) => {
  const [phaseIdx, setPhaseIdx] = useState(0);
  const [animKey, setAnimKey] = useState(0);
  const audioRef = useRef(null);

  const phase = PHASES[phaseIdx];

  useEffect(() => {
    try { audioRef.current?.play().catch(() => {}); } catch (e) { /* ignore */ }
    setAnimKey(k => k + 1);

    if (phase?.final) return;
    if (!phase) return;

    const timer = setTimeout(() => {
      if (phaseIdx < PHASES.length - 1) {
        setPhaseIdx(p => p + 1);
      }
    }, phase.duration);

    return () => clearTimeout(timer);
  }, [phaseIdx, phase]);

  useEffect(() => {
    if (phase?.final) {
      const timer = setTimeout(onClose, phase.duration);
      return () => clearTimeout(timer);
    }
  }, [phase, onClose]);

  if (!phase) return null;

  return (
    <div
      className={`fixed inset-0 z-[10000] ${phase.bg} flex items-center justify-center cursor-pointer transition-colors duration-300`}
      onClick={onClose}
      data-testid="attention-getter-overlay"
    >
      <audio ref={audioRef} preload="auto">
        <source src="data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACBhYqFbF1fdJivrJBhNjVgodDbq2EcBj+a2teleAILxv/C/8L/wv/C/8L/wv/C/8L/wv/C/8L/wv/C/8L/wv/C/8L/wv/C/8L/wv/C/8L/wv/C/8L/wv/C/8L/wv/C/8L/wv/C/8L/wv/C/8L/wv/C/8L/wv/C/8L/wv/C/8L/wv/C/8L/wv/C/w==" type="audio/wav" />
      </audio>

      <div key={animKey} className="text-center select-none animate-attention-pop">
        <span
          className={`font-heading font-black text-white leading-none whitespace-pre-line drop-shadow-2xl ${
            phase.final ? 'text-[6rem] sm:text-[10rem] lg:text-[12rem]' : 'text-[12rem] sm:text-[18rem] lg:text-[22rem]'
          }`}
          style={{ lineHeight: '1.1' }}
        >
          {phase.text}
        </span>
      </div>

      <button
        onClick={(e) => { e.stopPropagation(); onClose(); }}
        className="absolute top-6 right-6 p-3 rounded-full bg-white/10 hover:bg-white/20 text-white/60"
      >
        <X className="w-6 h-6" />
      </button>

      <div className="absolute bottom-8 flex items-center gap-2">
        {PHASES.map((_, i) => (
          <div
            key={i}
            className={`w-2.5 h-2.5 rounded-full transition-all ${i === phaseIdx ? 'bg-white scale-125' : 'bg-white/30'}`}
          />
        ))}
      </div>
    </div>
  );
};
